// Is the ArcDisk demo on for the person using the app right now?
// The `arcdisk-demo` feature flag as the backend resolves it for the signed-in
// user: their selected school's features, or the global Flipper flags when
// they have no school (see config.ts). While the flags are still loading the
// answer is "not yet": callers that would redirect or fall through to
// Mosaico's own page check the loading state first.
import { useFeatureToggle, useFeatureToggleLoading } from 'hooks/useFeatureToggle'
import { ARCDISK_DEMO_FLAG } from './config'

export function useArcDiskDemoEnabled(): boolean {
  return useFeatureToggle(ARCDISK_DEMO_FLAG) as boolean
}

export function useArcDiskDemoLoading(): boolean {
  return useFeatureToggleLoading()
}
